export const ROLES = {
  MASTER_ADMIN: 'master_admin',
  SUPER_ADMIN: 'super_admin',
  SERVICE_ADMIN: 'service_admin',
  SERVICE_USER: 'service_user',
  OPERATOR_ADMIN: 'operator_admin',
  OPERATOR_USER: 'operator_user'
} as const;

export const USER_TYPES = {
  SERVICE: 'service',
  BUSINESS: 'business'
} as const;

export const CALL_TYPES = {
  INCOMING: 'IN',
  OUTGOING: 'OUT'
} as const;

export const CALL_STATUS = {
  ANSWERED: 'answered',
  MISSED: 'missed',
  BUSY: 'busy',
  COMPLETED: 'completed'
} as const;

export const LANGUAGES = [
  { value: 'en', label: 'English' },
  { value: 'hi', label: 'Hindi' },
  { value: 'es', label: 'Spanish' }
];

export const ITEMS_PER_PAGE = 10;

// Default date range for operational data pages (CallLogs, AudioSessions, Transfers)
// This defines how many days back from today to show by default
// Value of 2 means: today + 1 day before = last 2 days including today
export const DEFAULT_DATE_RANGE_DAYS = 2;

// Default date range for Dashboard (kept at 7 days for better overview)
export const DASHBOARD_DATE_RANGE_DAYS = 7;

/**
 * Light-mode categorical series, in fixed slot order.
 * Kept as a constant for call sites that can't reach the theme hook — prefer
 * getChartTheme(resolvedTheme) from 'styles/chartTheme' so dark mode is covered.
 */
export const CHART_COLORS = ['#C24A22', '#008C74', '#DE9220', '#96345F', '#4E7C18'];

// Feature Flags
export const FEATURE_FLAGS = {
  // When true, operational data pages (CallLogs, Sessions, Recordings, Transfers)
  // require specific organization selection for master_admin and super_admin users.
  // When false, they can select "All Organizations" (legacy behavior - may cause pagination issues)
  REQUIRE_ORG_SELECTION_FOR_OPERATIONAL_DATA: true,

  // ── Temporary: hidden while the outbound dialler migration finishes ───────
  // OBD (bulk outbound dialer) and Standard voice campaigns are only half
  // switched on: parts of them do nothing, and the parts that do work place
  // real phone calls. Until the migration lands they are hidden from the UI —
  // the tab, and the route that deep-links to it, both check these flags.
  //
  // Nothing is deleted. Flip a flag back to true to restore that surface.
  // WhatsApp campaigns are LIVE and are not affected by either flag.
  SHOW_STANDARD_CAMPAIGNS: false,
} as const;
/**
 * Languages offered by the Audio Sessions language filter.
 *
 * These match `connection_state` as the IVR runtime writes it, so the values
 * are the runtime's spelling, not display names. The list is deployment-wide
 * rather than per-tenant: the Africa portal it came from serves Zimbabwe, and
 * an Indian tenant will simply never match Shona or Ndebele. If a region needs
 * a different set, change it here — it is the only place the list exists.
 */
export const CONVERSATION_LANGUAGES = ['English', 'Shona', 'Ndebele'] as const;
